export class Trpaccpartno {
    public PARTID!: number;
    public ACC_CODE!: string;
    public PART_NO!: string;
    public QTY_PERBOX!: number;
    public OTH_PARTY!: string;
    public H!: number;
    public L!: number;
    public W!: number;
    public CFT!: number;
    public ACT_WT!: number;
    public ITEM_DESC!: string;
    public FREIGHT_ON!: string;
    public PART_NO2!: string;
    public PART_NO3!: string;
    public PART_QTY1!: number;
    public PART_QTY2!: number;
    public PART_QTY3!: number;
    public WEIGHT_BOX!: number;
    public WEIGHT_PERQTY!: number;
    public CHG_WT!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}